module.exports = __webpack_public_path__ + "static/1_1_defineai_SL-2eb6b83914ad54a3305937bb95f532a8.svg";